 
import request from '@/axios'

// 退款申请
export function getTuiShenqing(data={}) {
    return request({
        url: '/pay/refund/list',
        method: 'get',
        params: data
    })
}

// 退款申请导出
export function getTuiExport(data={}) {
    return request({
        url: '/pay/refund/export',
        method: 'get',
        params: data
    })
}

// 退款申请提交
export function batchConfirm(data={}) {
    return request({
        url: '/pay/refund/confirm',
        method: 'post',
        data: data.batchName
    })
}

// 退款申请导出
export function getBatch(data={}) {
    return request({
        url: '/pay/refund/batch/total',
        method: 'get',
        params: data
    })
}